import { LeadershipArticlesInputs } from './Articles';

export const articlesAndInsightsTransformer = (
    node
): LeadershipArticlesInputs => ({
    header: node.field_header,
    articles: node.relationships?.field_articles_and_insights.map((item) => ({
        id: item.id,
        title: item?.field_title,
        eyebrow: item?.field_category,
        description: item?.field_article_description,
        cta: {
            title: item.field_link?.title,
            uri: item.field_link?.uri,
        },
    })),
});
